import { FormikErrors } from 'formik'

import AgentService from '../../core/services/agent.service'
import {
  biggerThanZero,
  required,
  validEmail,
  validPhoneLength,
  validPhoneNumber,
} from '../_utils/formValidators'
import { ContactDataInfoValues } from './ContactMe.view'

const validateEmail = (email: string) => {
  return required.default(email) || validEmail.default(email)
}

const validatePhoneNumber = (phone: string) => {
  return phone
    ? validPhoneLength.default(phone) || validPhoneNumber.default(phone)
    : undefined
}

const validatePrivacyPolicy = (checkboxChecked: boolean) => {
  return biggerThanZero('validator.privacyPolicySelected')(
    Number(checkboxChecked),
  )
}

export const validateFieldForm = (formValueFields: ContactDataInfoValues) => {
  const errors: FormikErrors<ContactDataInfoValues> = {}

  if (required.default(formValueFields.company)) {
    errors.company = required.default(formValueFields.company)
  }

  if (required.default(formValueFields.firstName)) {
    errors.firstName = required.default(formValueFields.firstName)
  }

  if (required.default(formValueFields.lastName)) {
    errors.lastName = required.default(formValueFields.lastName)
  }

  if (validateEmail(formValueFields.email)) {
    errors.email = validateEmail(formValueFields.email)
  }

  if (validatePhoneNumber(formValueFields.phone)) {
    errors.phone = validatePhoneNumber(formValueFields.phone)
  }

  if (
    !AgentService.isAgentOrBroker() &&
    validatePrivacyPolicy(formValueFields.acceptedPrivacyPolicy)
  ) {
    errors.acceptedPrivacyPolicy = validatePrivacyPolicy(
      formValueFields.acceptedPrivacyPolicy,
    )
  }

  return errors
}
